<div class="g-0">
    <div class="row">
        <div class="col">
            <div class="box-wrapper box-actiuni-cerere">
                <div class="box-content-header">
                    <div class="row p-1">
                        <div class="col">
                            <mat-card-title>
                                <i class="fa-solid fa-pen-to-square"></i>
                                <span>Acțiuni Document</span>
                            </mat-card-title>
                        </div>
                    </div>
                </div>

                <div class="box-content-body">
                    <div class="col p-2 d-flex justify-content-start">
                        <div>
                            <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                                (change)="onActionChange($event)" value="status">
                                <mat-button-toggle
                                    *ngIf="permissionsService.hasPermission('indoc-module.registratura_documents.document-view.actualizare-status')"
                                    value="status">Status</mat-button-toggle>
                                <mat-button-toggle
                                    *ngIf="permissionsService.hasPermission('indoc-module.registratura_documents.document-view.actualizare-prioritate')"
                                    value="prioritate">Prioritate</mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col" *ngIf="selectedActionToggle == 'status'">
                            <div
                                *ngIf="permissionsService.hasPermission('indoc-module.registratura_documents.document-view.actualizare-status')">
                                <form [formGroup]="sendUpdateStatusForm" (ngSubmit)="submitUpdateStatusMessage()">
                                    <div class="row p-1">
                                        <div class="col">
                                            <mat-form-field class="w-100" appearance="fill">
                                                <mat-label>Status</mat-label>
                                                <mat-select formControlName="current_status">
                                                    <mat-option *ngFor="let status of requestStatuses"
                                                        [value]="status.id">
                                                        {{ status.name }}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-error>Selectați un status</mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row p-1">
                                        <div class="col">
                                            <div class="fw-bold">Detalii</div>
                                            <angular-editor formControlName="message"
                                                [config]="editorConfig"></angular-editor>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <div class="col d-flex justify-content-end">
                                                <button [disabled]="sendUpdateStatusForm.invalid"
                                                    class="btn btn-light upload-btn m-3" type="submit">
                                                    <span class="upload__text">TRIMITE</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                        <div class="col" *ngIf="selectedActionToggle == 'prioritate'">
                            <div
                                *ngIf="permissionsService.hasPermission('indoc-module.registratura_documents.document-view.actualizare-prioritate')">
                                <form [formGroup]="sendUpdatePriorityForm" (ngSubmit)="submitUpdatePriorityMessage()">
                                    <div class="row p-1">
                                        <div class="col">
                                            <mat-form-field class="w-100" appearance="fill">
                                                <mat-label>Prioritate</mat-label>
                                                <mat-select formControlName="id_priority">
                                                    <mat-option *ngFor="let row of requestPriorities" [value]="row.id">
                                                        {{ row.name }}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-error>Selectați o prioritate</mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row p-1">
                                        <div class="col">
                                            <div class="fw-bold">Detalii</div>
                                            <angular-editor formControlName="message"
                                                [config]="editorConfig"></angular-editor>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <div class="col d-flex justify-content-end">
                                                <button [disabled]="sendUpdatePriorityForm.invalid"
                                                    class="btn btn-light upload-btn m-3" type="submit">
                                                    <span class="upload__text">TRIMITE</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>